import React, { Component } from "react";
import { Link } from "react-router-dom";

// CSS
import "../../styles/newDesign.scss";
import "../../styles/authForm.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Helper
import { resolveTenant, login, saveSession, isLoggedIn } from "../../Helper/Api";

const properties = require("../../properties.json");

class SignIn extends Component {
  state = {
    tenant: null,
    notFound: false,
    email: "",
    password: "",
    buttonText: "Sign in",
    submitting: false,
    msg: null,
  };

  componentDidMount() {
    document.title = properties.site_name + " - Sign in";

    if (isLoggedIn()) {
      window.location.href = "/";
      return;
    }

    resolveTenant()
      .then((tenant) => this.setState({ tenant }))
      .catch(() => this.setState({ notFound: true }));
  }

  submit = (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ msg: { text: "Please enter your email and password.", type: "warning" } });
      return;
    }

    this.setState({ submitting: true, buttonText: "Signing in...", msg: null });

    login(email, password)
      .then((user) => {
        saveSession(user.token, user);
        this.setState({ msg: { text: "Signed in successfully.", type: "success" } });
        setTimeout(() => {
          window.location.href = "/";
        }, 800);
      })
      .catch((error) => {
        this.setState({
          submitting: false,
          buttonText: "Sign in",
          msg: { text: error.message || "Incorrect login details.", type: "warning" },
        });
      });
  };

  render() {
    const { tenant, notFound, buttonText, submitting, msg } = this.state;

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>No page was found for this domain.</p>
          </div>
        </div>
      );
    }
    if (!tenant) return null;

    return (
      <>
        <Header tenant={tenant} />

        <div className="nd-page">
          <div className="auth-wrap">
            <div className="auth-box">
              <div className="auth-tabs">
                <span className="auth-tab active">Sign in</span>
                <Link to="/sign-up" className="auth-tab">Create account</Link>
              </div>

              <div className="nd-eyebrow" style={{ marginBottom: 6 }}>Welcome back</div>
              <h1 style={{ fontSize: 26, marginBottom: 22 }}>Sign in to your account</h1>

              <form onSubmit={this.submit}>
                <div className="form-field">
                  <label htmlFor="email">Email</label>
                  <input
                    type="text"
                    id="email"
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="pass-code">Password</label>
                  <input
                    type="password"
                    id="pass-code"
                    value={this.state.password}
                    onChange={(e) => this.setState({ password: e.target.value })}
                  />
                </div>
                <button className={`nd-btn-dark auth-submit ${submitting ? "loading" : ""}`} type="submit" disabled={submitting}>
                  {buttonText}
                </button>
                {msg && <div className={`auth-msg ${msg.type}`}>{msg.text}</div>}
                <p className="auth-switch">
                  Don't have an account yet? <Link to="/sign-up">Create a new account</Link>
                </p>
              </form>
            </div>
          </div>
        </div>

        <Footer tenant={tenant} />
      </>
    );
  }
}

export default SignIn;
